module.exports = __webpack_public_path__ + "media/images/icon/icons8-List-3b09e109604eaeef2181e3922a9ae395.png";